import { FeePostApplyOffsetsPage } from "features/fees/post/apply-offsets/FeePostApplyOffsetsPage";
import { useConfirmDeleteDraftLateOffsetsAdjustmentEvent } from "features/fees/post/apply-offsets/FeePostReviewLateOffsetsPage";
import React from "react";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const FeePostLateApplyOffsetsPage: React.FC = () => {
  const { fundFamilyId, feeChargeEventId, adjustmentFundFamilyEventId } =
    useRequiredStringParams();
  const onClickDelete = useConfirmDeleteDraftLateOffsetsAdjustmentEvent(
    fundFamilyId,
    feeChargeEventId,
  );
  return (
    <FeePostApplyOffsetsPage
      adjustmentFundFamilyEventId={adjustmentFundFamilyEventId}
      onClickDelete={() => onClickDelete({ adjustmentFundFamilyEventId })}
    />
  );
};
